import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

// Company settings → Pre-construction (the prototype's settings card): the
// "Budget versions" checkbox asks first (the effect isn't obvious), then
// saves without a reload.
export default class extends Controller {
  static targets = ["option", "checkbox", "badge", "next", "modal", "title", "text", "sub", "ok"]
  static values = { url: String, onTitle: String, offTitle: String, onText: String, offText: String, onSub: String, offSub: String,
                    onBtn: String, offBtn: String, onBadge: String, offBadge: String, savedOn: String, savedOff: String, error: String }

  ask(e) {
    // In a click handler the box has already flipped (preventDefault flips it
    // back afterwards): its state now is what the person asked for.
    const on = this.checkboxTarget.checked
    e.preventDefault() // the box only changes after the confirm
    this._want = on
    this.titleTarget.textContent = on ? this.onTitleValue : this.offTitleValue
    this.textTarget.textContent = on ? this.onTextValue : this.offTextValue
    this.subTarget.textContent = on ? this.onSubValue : this.offSubValue
    this.okTarget.textContent = on ? this.onBtnValue : this.offBtnValue
    this.modalTarget.classList.remove("hidden")
  }

  stop(e) { e.stopPropagation() }

  cancel() { this.modalTarget.classList.add("hidden") }

  async confirm() {
    const on = this._want
    this.modalTarget.classList.add("hidden")
    this._paint(on) // optimistic
    try {
      const token = document.querySelector("meta[name='csrf-token']")?.content
      const res = await fetch(this.urlValue, { method: "PATCH", headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": token }, body: JSON.stringify({ precon_budget_versions: on ? "1" : "0" }) })
      if (!res.ok) throw new Error()
      this._toast(on ? this.savedOnValue : this.savedOffValue)
      track(on ? "Precon Budget Versions Turned On" : "Precon Budget Versions Turned Off", {})
    } catch (_e) {
      this._paint(!on)
      this._toast(this.errorValue, "error")
    }
  }

  _paint(on) {
    this.checkboxTarget.checked = on
    this.optionTarget.classList.toggle("on", on)
    this.badgeTarget.textContent = on ? this.onBadgeValue : this.offBadgeValue
    this.badgeTarget.classList.toggle("b-green", on)
    this.badgeTarget.classList.toggle("b-gray", !on)
    this.nextTarget.classList.toggle("hidden", !on)
  }

  _toast(message, type = "notice") {
    const toast = document.createElement("div")
    toast.className = type === "error" ? "flash-toast-alert" : "flash-toast-notice"
    toast.setAttribute("data-controller", "flash")
    toast.setAttribute("data-flash-dismiss-after-value", "5000")
    toast.textContent = message
    document.body.prepend(toast)
  }
}
